import "reflect-metadata";
import {inject, injectable} from "inversify";
import {CompanyConfigurationRepository} from "@dropDesk/domain/repositories/company_configurations/company_configurations.repository";
import {TicketConfigurationEntity} from "@dropDesk/domain/entities/company_configurations/ticket_configuration.entity";
import {CompanyConfigurationEntity} from "@dropDesk/domain/entities/company_configurations/company_configuration.entity";

@injectable()
export class SetTicketConfigurationsUseCase {
  private _repository: CompanyConfigurationRepository;

  constructor(@inject(CompanyConfigurationRepository) repository: CompanyConfigurationRepository) {
    this._repository = repository;
  }

  public call(configurationTicket: TicketConfigurationEntity): Promise<CompanyConfigurationEntity> {
    return this._repository.setConfigurationTicket(configurationTicket);
  }
}
